


















import { Component, Mixins, Prop } from "vue-property-decorator";
import { Size } from "../../domain/drawing";
import { DragKinds } from "./DragKinds";
import { DragHandleMixin } from "./mixins";

@Component({
})
export default class RectangleResizeDragHandle extends Mixins(DragHandleMixin) {
  @Prop()
  size: Size;

  data(): any {
    return {
      styles: this.createStyles(),
    };
  }
  styles: { classSuffix: string, toStyle: (s: Size) => any }[];

  private createStyles(): { classSuffix: string, toStyle: (s: Size) => any }[] {
    const results: { classSuffix: string, toStyle: (s: Size) => any }[] = [];
    results[DragKinds.TopLeft] = {
      classSuffix: "top-left",
      toStyle: s => {
        return {
          top: (-s.height / 2) + "px",
          left: (-s.width / 2) + "px",
        };
      },
    };
    results[DragKinds.TopRight] = {
      classSuffix: "top-right",
      toStyle: s => {
        return {
          top: (-s.height / 2) + "px",
          right: (-s.width / 2) + "px",
        };
      },
    };
    results[DragKinds.BottomLeft] = {
      classSuffix: "bottom-left",
      toStyle: s => {
        return {
          bottom: (-s.height / 2) + "px",
          left: (-s.width / 2) + "px",
        };
      },
    };
    results[DragKinds.BottomRight] = {
      classSuffix: "bottom-right",
      toStyle: s => {
        return {
          bottom: (-s.height / 2) + "px",
          right: (-s.width / 2) + "px",
        };
      },
    };
    results[DragKinds.Top] = {
      classSuffix: "top",
      toStyle: s => {
        return {
          top: (-s.height / 2) + "px",
          left: ((this.width - s.width) / 2) + "px",
        };
      },
    };
    results[DragKinds.Bottom] = {
      classSuffix: "bottom",
      toStyle: s => {
        return {
          bottom: (-s.height / 2) + "px",
          left: ((this.width - s.width) / 2) + "px",
        };
      },
    };
    results[DragKinds.Left] = {
      classSuffix: "left",
      toStyle: s => {
        return {
          top: ((this.height - s.height) / 2) + "px",
          left: (-s.width / 2) + "px",
        };
      },
    };
    results[DragKinds.Right] = {
      classSuffix: "right",
      toStyle: s => {
        return {
          top: ((this.height - s.height) / 2) + "px",
          right: (-s.width / 2) + "px",
        };
      },
    };
    return results;
  }

  get width(): number {
    return this.size.width;
  }

  get height(): number {
    return this.size.height;
  }

  get className(): string {
    return "rectangle-resize-drag-handle-" + this.styles[this.kind].classSuffix;
  }

  get locationStyle(): any {
    return this.styles[this.kind].toStyle(this.handleSize);
  }
}
